<template>
    <CreatePartyQuest />
</template>

<script>
import CreatePartyQuest from '../components/CreatePartyQuest.vue';

export default {
    name: 'CreatePQ',

    components: {
        CreatePartyQuest,
    },
};
</script>
